import { createActiveScopes } from "services/sync/activeScopes";
import { invalidateSync} from "services/sync/engine";

export function SyncEngine(repository, { isLeader }) {
  const activeScopes = createActiveScopes();

  const invalidate = (scope, key) => {
    invalidateSync(repository, scope, key);
  }

  return {
    activeScopes,
    invalidate,
    repository,
    isLeader
  };
}